export default __webpack_public_path__ + "static/media/safe-auto-logo.c82a6e03.png";